import { render, staticRenderFns } from "./CategoryNodes.vue?vue&type=template&id=12dc39a9&"
import script from "./CategoryNodes.vue?vue&type=script&lang=js&"
export * from "./CategoryNodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports